/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S7_P1Inputs */

const tr_mesafeli_s7_p1 = /** @type {(inputs: Mesafeli_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6502 sayılı Kanun Madde 48 ve Mesafeli Sözleşmeler Yönetmeliği uyarınca, tüketici sıfatını haiz Müşteri 14 (on dört) gün içinde herhangi bir gerekçe göstermeksizin Sözleşme'den cayma hakkına sahiptir.`)
};

const en_mesafeli_s7_p1 = /** @type {(inputs: Mesafeli_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pursuant to Article 48 of Law No. 6502 and the Mesafeli Sözleşmeler Yönetmeliği, a Customer having consumer status has the right to withdraw from the Agreement within 14 (fourteen) days without giving any reason.`)
};

const de_mesafeli_s7_p1 = /** @type {(inputs: Mesafeli_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemäß Artikel 48 des Gesetzes Nr. 6502 und der Mesafeli Sözleşmeler Yönetmeliği hat der Kunde, der Verbrauchereigenschaft besitzt, das Recht, innerhalb von 14 (vierzehn) Tagen ohne Angabe von Gründen vom Vertrag zurückzutreten.`)
};

const ru_mesafeli_s7_p1 = /** @type {(inputs: Mesafeli_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Согласно статье 48 Закона № 6502 и Mesafeli Sözleşmeler Yönetmeliği Клиент, имеющий статус потребителя, вправе в течение 14 (четырнадцати) дней отказаться от Договора без объяснения причин.`)
};

/**
* | output |
* | --- |
* | "Pursuant to Article 48 of Law No. 6502 and the Mesafeli Sözleşmeler Yönetmeliği, a Customer having consumer status has the right to withdraw from the Agreeme..." |
*
* @param {Mesafeli_S7_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s7_p1 = /** @type {((inputs?: Mesafeli_S7_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S7_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s7_p1(inputs)
	if (locale === "de") return de_mesafeli_s7_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s7_p1(inputs)
	return tr_mesafeli_s7_p1(inputs)
});